"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";

function ThemeTransitionController() {
  const { resolvedTheme } = useTheme();
  const previousTheme = React.useRef<string | undefined>(undefined);

  React.useEffect(() => {
    if (!resolvedTheme) return;

    // Don't animate on the very first resolve (initial mount).
    if (previousTheme.current === undefined) {
      previousTheme.current = resolvedTheme;
      return;
    }

    if (previousTheme.current === resolvedTheme) return;
    previousTheme.current = resolvedTheme;

    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    const root = document.documentElement;
    root.classList.add("theme-transition");

    const timeout = window.setTimeout(() => {
      root.classList.remove("theme-transition");
    }, 320);

    return () => window.clearTimeout(timeout);
  }, [resolvedTheme]);

  return null;
}

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <ThemeTransitionController />
      {children}
    </NextThemesProvider>
  );
}
